import { Injectable } from '@angular/core';
import { FeatureFlagsService } from '@skylab-angular-shared/config';
import { FeatureFlagsRulesService, Wrapper } from '@skylab-angular-shared/core';
import { SaleFeatureFlagsRulesServiceBase } from '@skylab-shared/business';

@Injectable({ providedIn: 'root'})
@Wrapper(SaleFeatureFlagsRulesServiceBase)
export class SaleFeatureFlagsRulesService {
    public constructor(
        featureFlagsService: FeatureFlagsService,
        featureFlagsRules: FeatureFlagsRulesService
    ) { }
}
